jQuery(document).ready(function ($) {

    var payouts = 'payouts';
});

